<ng-container *ngFor="let attachment of transformedAttachment">
  <div class="two-column-container">
    <div class="column">
      <span class="link paragraph-medium-regular" tabindex='0'
        (keypress)="downloadAttactment(attachment)" (click)="downloadAttactment(attachment)">{{ attachment.FileName|
        truncateMiddle:56 }}</span>
    </div>
    <div class="column">
      <div class="paragraph-small-regular">
        <span *ngIf="
          attachment.AttachmentTypeId === AttachmentTypeId.INVITATION_TO_TENDER">Invitation to Tender</span>
        <span *ngIf="
          attachment.AttachmentTypeId ===
          AttachmentTypeId.SECTION_CONDITION_TO_TENDER
        ">
          Section 1 - Conditions of Tender
        </span>
        <span *ngIf="
          attachment.AttachmentTypeId === AttachmentTypeId.SECTION_SCOPE_OF_WORK
        ">
          Section 3 - Scope of Work </span>
        <span *ngIf="
            attachment.AttachmentTypeId ===
            AttachmentTypeId.SECTION_CONDITION_TO_CONTRACT
          ">
          Section 2 - Conditions of Contract</span>
        <span *ngIf="
            attachment.AttachmentTypeId ===
            AttachmentTypeId.SECTION_TENDER_RESPONSE_FORM
          ">
          Section 4 - Tender Response Form </span>
      </div>
    </div>
  </div>
</ng-container>